/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React, { useState } from 'react';
import MarkdownText from 'components/common/MarkdownText';

interface MarkdownHelpProps {
  text?: string;
  mon?: any; // Adjust this type according to the actual structure of `mon`
}

const MarkdownHelp: React.FC<MarkdownHelpProps> = ({ text, mon }) => {
  const [sampleText, setSampleText] = useState<string>(
    'This is *italicized*, and so is _this_\n' +
    'This is **bold**, and so is __this__\n' +
    'This is ***bold and italicized***, and so is ___this___, _**this**_, **_this_** and __*this*__' +
    '\nThis is a list:\n* item 1\n* item 2 with **bold** content' +
    '\nThis is another list:\n- item 1\n- item 2' +
    '\n> This block is indented. Even where there is a lot of text, the content of the text stays indented as it spans multiple lines' +
    '\n>> This block is indented even more!' +
    '\nThis is a table:' +
    '\n|Header Row| 2nd column| 3rd col|' +
    '\n|----------|--|-|' +
    '\n|First Row|' +
    '\n|Second Row|some|content|' +
    '\n|Final|row|of data|' +
    '\n\n horizontal lines are three or more \'-\' characters by themselves:\n-----' +
    '\n# header1' +
    '\n## header2' +
    '\n### header3' +
    '\n#### header4' +
    '\n##### header5' +
    '\n###### header6' +
    ''
  );

  const monsterKeys = 
    '|Key|Results|' +
    '\n|---|-------|' +
    '\n|[MON] or [MONS]|The monster\'s name, or plural form exactly as written|' +
    '\n|[mon] or [mons]|The monster\'s name in lowercase|' +
    '\n|[Mon] or [Mons]|The name with first letter capitalized|' +
    '\n|[2d8], [1d4+2], etc.|The raw dice rolls, showing average roll|' +
    '\n|[STR] or [INT], etc.|The attribute\'s modifier|' +
    '\n|[PB], [prof], [PB+2], etc.|Proficiency Bonus, optionally modified|' +
    '\n|[STR ATK], [DEX ATK]|The to-hit modifier for that attribute|' +
    '\n|[STR 2d6], [DEX 1d8 + 2]|The damage for an attack using that attr.|' +
    '\n|[WIS SAVE +3], [INT SAVE], etc.|Computes the save DC vs. that attribute of the monster|';

  return (
    <span className="ability-container" id='markdownHelp' >
      <span className="multi-select-panel help">
        <MarkdownText text={monsterKeys} mon={null}/>
        <br />Basic markdown (edits made will update in real-time):
        <textarea 
          className='help-text' 
          onChange={(event) => setSampleText(event.target.value)} 
          value={sampleText} // Using `value` instead of children to ensure controlled input
        />
        <br /><b><u>Results of markdown:</u></b><br />
        <div style={{textAlign: 'left'}}>
          <MarkdownText text={sampleText} mon={null}/>
        </div>
      </span>
    </span>
  );
}

export default MarkdownHelp;
